import { render, staticRenderFns } from "./booksearch.vue?vue&type=template&id=fd6d7b64&scoped=true&"
import script from "./booksearch.vue?vue&type=script&lang=js&"
export * from "./booksearch.vue?vue&type=script&lang=js&"
import style0 from "./booksearch.vue?vue&type=style&index=0&id=fd6d7b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6d7b64",
  null
  
)

component.options.__file = "booksearch.vue"
export default component.exports